import * as React from 'react'

import { HeroRedesign } from 'sdk/sections/hero-redesign/HeroRedesign'

import sdkIcon from 'shared/assets/icons/sdk.svg'
import sdkHeroBgLarge from '../../assets/sdk-hero-bg-large.jpg'
import sdkHeroBgSmall from '../../assets/sdk-hero-bg-small.jpg'
import sdkHeroBgXsm from '../../assets/sdk-hero-bg-xsm.jpg'

export const Hero: React.FC = () => {
  return (
    <HeroRedesign
      imageDesktop={sdkHeroBgLarge}
      imageTablet={sdkHeroBgSmall}
      imageMobile={sdkHeroBgXsm}
      pillText='Build the impossible'
      pillIcon={sdkIcon}
      titleText='The GPU Audio SDK'
      description={<>Enable audio applications that were technically impossible before GPU acceleration</>}
    />
  )
}
